import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Marker, withLeaflet} from 'react-leaflet';

import { is768Query } from '~/core/scripts/mediaquery-helper';
import presets from './presets';

function getLabels(labelPreset, customLabels = []) {
  const screenSizeKey = is768Query() ? 'desktop' : 'mobile';
  // handle preset labels
  const hasPresetData = labelPreset && typeof presets[labelPreset] !== 'undefined';
  const presetLabels = hasPresetData ? presets[labelPreset][screenSizeKey] : [];

  // handle custom labels
  const hasCustomLabels = customLabels && typeof customLabels[screenSizeKey] !== 'undefined';
  const customLabelsArray = hasCustomLabels ? customLabels[screenSizeKey] : [];

  return [...presetLabels, ...customLabelsArray];
}

class LablesLayer extends PureComponent {
  static propTypes = {
    preset: PropTypes.string,
    labels: PropTypes.array
  }

  static defaultProps = {
    preset: null,
    labels: null
  }

  state = {
    zoomLevel: 0,
    zoomInitialized: false
  }

  constructor(props) {
    super();
    props.leaflet.map.on('zoomend', (evt) => this.updateZoom(evt));
  }

  updateZoom(evt) {
    this.setState({
      zoomInitialized: true,
      zoom: evt.target._zoom
    });
  }

  getLabels() {
    const { labels, preset } = this.props;
    const { zoom } = this.state;

    const hasPresetData = preset && typeof presets[preset] !== 'undefined';
    const presetLabels = hasPresetData ? presets[preset].filter(p => p[3] <= zoom && p[4] >= zoom) : [];

    const hasCustomLabels = labels && typeof labels !== 'undefined';
    const customLabelsArray = hasCustomLabels ? labels.filter(p => p[3] <= zoom && p[4] >= zoom) : [];

    return [...presetLabels, ...customLabelsArray];
  }

  render() {
    if (!this.state.zoomInitialized) {
      return false;
    }

    return (
      this.getLabels().map(d => {
        const icon = L.divIcon({  className: 'map-label', html: d[0] });
        return (
          <Marker
            key={`MapLabel__${d[0]}`}
            position={[d[1], d[2]]}
            icon={icon}
          />
        );
      })
    );
  }
}

export default withLeaflet(LablesLayer);
